module.exports = __webpack_public_path__ + "img/1.062689f9.gif";